import React from "react";

export function ColorCubeIcon(props) {
    return React.createElement(
        "svg",
        Object.assign(
            {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                height: "280",
                width: "280",
                viewBox: "0 0 280 280",
                stroke: "currentColor",
            },
            props
        ),
        React.createElement("g", {
            fill: "#45984b",
            children: [
                React.createElement("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    key: "vertex1",
                    d: "M140.648886,139.968493 L22.350093,72.466588 L139.853409,4.055566 L257.470366,72.012030 L140.648886,139.968493 Z",
                }),
            ],
        }),
        React.createElement("g", {
            fill: "#4aaa51",
            children: [
                React.createElement("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    key: "vertex2",
                    d: "M140.535247,274.995060 L22.350093,207.265876 L22.350093,71.352948 L140.648886,139.423052 L140.535247,274.995060 Z",
                }),
            ],
        }),
        React.createElement("g", {
            fill: "#3c8642",
            children: [
                React.createElement("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    key: "vertex3",
                    d: "M140.648886,275.108700 L257.697645,207.265876 L257.356726,71.125669 L140.535247,139.195773 L140.648886,275.108700 Z",
                }),
            ],
        })
    );
}

export default ColorCubeIcon;
